import { logger } from 'helpers'
var installation = {}
try {
  installation = require('../projects/' + process.env.REACT_APP_PROJECT + '/config/installation')
} catch (e) {
  logger.debug('No project-specific installation-config for installation')
}
module.exports = installation



// WEBPACK FOOTER //
// ./src/config/installation.js